/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { Item } from "libs/sysque/toolbelt/data-access/src/lib/domain/item"
import { ServiceType } from "../../models/family-information-model"

export interface IFamilyInformationItem extends Item {
  isFromEdit: boolean
  isFromDuplicate: boolean
  isFromAdd: boolean
  systemName: string
  electricalType: string
  isClearence: boolean
  partType: string
  isWall: boolean
  connectorCount: number
  lineWeight: string
  linePattern: string
  length: string;
  serviceTypes: ServiceType[];
  supportDiscipline: string;
  parameters: Parameters | undefined;
  pushParameters: string;
  material: string;
  csvName: string;
  panelCircuitChecked: boolean;
  totalBendRun: string;
  addedWireLength: string;
  isEquipment: boolean;
  jBoxType: string;
  pdfLocation: string;
  isUpgradeFieldFabBend: boolean;
  takeUp: string;
  extraField: string;
  familyCategoryName : string;
  leadOutLength: string;
  guid: string;
  model: string;
  nominalSize: string;
  userCustomFamilyID: string;
  hangerAsFitting: boolean;
}

//#region Data Project Params
export interface Parameters {
  parameters: Param[]
}
export interface Param {

  name: string
  value: string
  type: string
  category: string
  group: string
  groupParameterUnder: string
  isInstance: string
  isShared: string
  lstSizes: ParamSize[]
  isPushOption: boolean
  index: number,
  isPushedChecked: boolean
}

export interface ParamSize {
  id: string
  value: string
}

export class FieldFabConduitSizeRangeVM {
  sizeRange?: string
  bendRadius?: string
  leadLength?: string
  takeUp?: string

  constructor(sizeRange: string, bendRadius: string, leadLength: string, takeUp: string) {
    this.sizeRange = sizeRange
    this.bendRadius = bendRadius
    this.leadLength = leadLength
    this.takeUp = takeUp
  }
}

export class HandAndMachineBendSizeRangeVM {
  sizeRange?: string
  bendRadius?: string
  leadLength?: string
  leadOutLength?: string
  takeUp?: string

  constructor(sizeRange: string, bendRadius: string, leadLength: string, leadOutLength: string, takeUp: string) {
    this.sizeRange = sizeRange
    this.bendRadius = bendRadius
    this.leadLength = leadLength
    this.leadOutLength = leadOutLength
    this.takeUp = takeUp
  }
}

export class KickHandAndMachineBendSizeRangeVM {
  sizeRange?: string
  bendRadius?: string
  minimumStubLength?: string
  deduct?: string

  constructor(sizeRange: string, bendRadius: string, minimumStubLength: string, deduct: string) {
    this.sizeRange = sizeRange
    this.bendRadius = bendRadius
    this.minimumStubLength = minimumStubLength
    this.deduct = deduct
  }
}

//#endregion
